// extracted by mini-css-extract-plugin
export var bar = "bar-progress-badge-module--bar--PjZ4R";
export var counter = "bar-progress-badge-module--counter--76yTl";
export var hasProgress = "bar-progress-badge-module--hasProgress--OCec8";
export var medal = "bar-progress-badge-module--medal--e1A2w";
export var medalWrapper = "bar-progress-badge-module--medal-wrapper--q4SWf";
export var medalWrapper__inactive = "bar-progress-badge-module--medal-wrapper__inactive--V0FD1";
export var medals = "bar-progress-badge-module--medals--xxuA6";
export var noProgress = "bar-progress-badge-module--noProgress--XwpwB";
export var shape = "bar-progress-badge-module--shape--kdEei";
export var toolTip = "bar-progress-badge-module--tool-tip--BiZFJ";